import { Link } from 'react-router-dom';
import routes from '@/routes';
import { useTranslation } from 'react-i18next';
import useLanguage from '@/hooks/useLanguage';
import classes from './header.module.css';
import LogoImage from '../../assets/images/logo.svg?react'; // eslint-disable-line import/no-unresolved
import LogoSmallImage from '../../assets/images/logo-small.svg?react'; // eslint-disable-line import/no-unresolved
import PersonImage from '../../assets/images/person.svg?react'; // eslint-disable-line import/no-unresolved

const Header = () => {
  const { t } = useTranslation();
  const { lng, localize, switchPath } = useLanguage();
  const otherLng = (lng === 'en') ? 'he' : 'en';

  return (
    <header className={classes.header}>
      <div className={classes.items}>
        <ul>
          <li>
            <Link to={localize(routes.personal.path)} className={classes.button}>
              <div className={classes.icon}><PersonImage style={{ height: '100%', width: 'auto' }} /></div>
              <div className={classes.text}>{t('components.header.items.info.title')}</div>
            </Link>
          </li>
          <li><Link to={localize(routes.service.path)}>{t('components.header.items.service.title')}</Link></li>
          <li><Link to={localize(routes.team.path)}>{t('components.header.items.team.title')}</Link></li>
          <li><Link to={localize(routes.contact.path)}>{t('components.header.items.contact.title')}</Link></li>
          <li>
            <Link to={switchPath(otherLng)} lang={otherLng}>
              {t('components.header.language')}
            </Link>
          </li>
        </ul>
      </div>
      <div className={classes.logo}>
        <Link to={localize(routes.main.path)} aria-label={t('components.header.title', { name: t('components.header.items.main.title') })}>
          <LogoImage className={classes.large} />
          <LogoSmallImage className={classes.small} />
        </Link>
      </div>
    </header>
  );
};

export default Header;
